import React, { useState, useEffect } from "react";
import {Ajax} from "../Service/ajax";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {hosts} from "../env/Environment";
import {CheckCircle, XCircle} from "lucide-react";
const OrganisationView = () => {
    const [loading, setLoading] = useState(false);
    const [etape, setEtape] = useState(1);
    const solution = JSON.parse(sessionStorage.getItem("solution"));
    const [categories, setCategories] = useState([]);
    const session = sessionStorage.getItem("session");
    const navigate = useNavigate();
    const [description, setDescription] = useState("");
    const [page, setPage] = useState("");
    const [realDescription, setRealDescription] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [organisationData, setOrganisationData] = useState({
        name: "",
        category_id: "",
        description: "",
    });

    const validateDescription = (description) => {
        const minLength = 10;
        const maxLength = 255;

        if (!description) return false;

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = description;
        const textContent = tempDiv.textContent || tempDiv.innerText || "";

        const cleaned = textContent.trim();

        const length = cleaned.length;

        return length >= minLength && length <= maxLength;
    };


    const isDescriptionValid = validateDescription(realDescription);



    const trf = sessionStorage.getItem("trf");
    const createApp = (name,organisation_id) => {
        const requestData = {
            title: name,
            organisation_id:organisation_id,
            description: description,
            page: page,
        };
        const fetchApp = async () => {
            try {
                const {data} = await Ajax.postRequest(`/api/v1/sub/application/create`,requestData);
                if(data.error){
                    Swal.fire({
                        title: 'Information',
                        text:`Votre organisation a ete cree avec success vous serez rediriger vers une autre page pour continuer`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000,
                        timerProgressBar: true,
                        didClose: () => {
                            navigate("/organisation");
                        }
                    });
                }else{
                    Swal.fire({
                        title: 'Success',
                        text:`Votre organisation a ete cree avec success vous serez rediriger vers une autre page pour continuer`,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000,
                        timerProgressBar: true,
                        didClose: () => {
                            navigate("/organisation");
                        }
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Information',
                    text:`Votre organisation a ete cree avec success vous serez rediriger vers une autre page pour continuer`,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000,
                    timerProgressBar: true,
                    didClose: () => {
                        navigate("/organisation");
                    }
                });
            }
        };
        fetchApp();
    };

    function validerTexte(input) {
        const regex = /^[a-z0-9\-_]+$/;
        return regex.test(input);
    }


    const handleSave = () => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const {data} = await Ajax.postRequest("/api/v1/usr/companies", organisationData);
                if(data.error){
                    Swal.fire({
                        title: 'Error!',
                        text:`${data.message}`,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000
                    });
                }else{
                    const {id,name,description} = data.payload;
                    if(data.payload){
                        createApp(name,id,description);
                        sessionStorage.setItem("success", "Organisation créée avec succès");
                        navigate("/organisation");
                    }else{
                        Swal.fire({
                            title: 'Information',
                            text:`Votre organisation a ete cree avec success vous serez rediriger vers une autre page pour continuer`,
                            icon: 'warning',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            didClose: () => {
                                navigate("/organisation");
                            }
                        });
                    }
                }
            } catch (error) {
                console.log(error.message);
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }finally {
                setLoading(false);
            }
        };
        fetchData();
    };


    useEffect(() => {
        if(session && trf){
            const fetchData = async (trf_id) => {
                try {
                    setLoading(true);
                    const {data} = await Ajax.getRequest(`/api/v1/cmp/categories?pge=1&sol=${solution.id}&grn=1&prt=all&lmt=100&slug=`);
                    if(data.error){
                        Swal.fire({
                            title: 'Information',
                            text:`${data.message}`,
                            icon: 'warning',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 50000,
                        })
                    }else{
                        setCategories(data.contents);
                    }
                    const company = await Ajax.getRequest(`/api/v1/cmp/companies?cat=all&sol=${solution.id}&slug=&pge=1&lmt=100`);
                    let nbOrganisation=company.data.contents.length;
                    if(nbOrganisation >= 1){
                        navigate("/particulier");
                    }
                } catch (error) {
                    navigate("/error-page", { state: { errorCode: error.response.status } });
                }finally {
                    setLoading(false);
                }
            };

            fetchData(JSON.parse(trf).trf_id);
        }else{
            navigate("/login?target=login");
        }
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setOrganisationData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleChangeNt = (value) => {
        setDescription(value);

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = value;
        const plainText = tempDiv.textContent || tempDiv.innerText || "";

        setRealDescription(plainText.trim());
        setOrganisationData((prevData)=>({
            ...prevData,
            ['description']: plainText.trim(),
        }))
    };


    const handleAbort = ()=>{
        navigate("/organisation");
    }

    const nextStep = () => {
        setEtape((prevEtape) => prevEtape + 1);
    };

    const prevStep = () => {
        setEtape((prevEtape) => prevEtape - 1);
    };

    const renderChampsEtape = () => {
        switch (etape) {
            case 1:
                return (
                    <>
                        <div className="input-group mb-3">
                          <span className="input-group-text" id="basic-addon11">
                            Nom
                          </span>
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={organisationData.name}
                                onChange={handleChange}
                                placeholder="Nom de l'organisation"
                                aria-label="orgName"
                                aria-describedby="basic-addon11"
                            />
                        </div>
                        <div className="input-group mb-3">
                            <label className="input-group-text" htmlFor="inputGroupSelect01">
                                Catégories
                            </label>
                            <select
                                className="form-select"
                                id="inputGroupSelect01"
                                name="category_id"
                                value={organisationData.category_id}
                                onChange={handleChange}
                            >
                                <option value="">Choisir...</option>
                                {categories.map((item, index) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </>
                );
            case 2:
                return (
                    <>
                        <div className="input-group mb-3">
                          <span className="input-group-text" id="basic-addon11">
                            Htag
                          </span>
                            <input
                                type="text"
                                className="form-control"
                                name="h_tag"
                                value={organisationData.h_tag.startsWith('$') ? organisationData.h_tag : `$${organisationData.h_tag}`}
                                onChange={handleChange}
                                placeholder="Htag de l'organisation"
                                aria-label="HTag"
                                aria-describedby="basic-addon11"
                            />
                        </div>
                        <div className="input-group mb-3">
                          <span className="input-group-text" id="basic-addon11">
                            Tags
                          </span>
                            <input
                                type="text"
                                className="form-control"
                                name="tags"
                                value={organisationData.tags}
                                onChange={handleChange}
                                placeholder="Tags de l'application"
                                aria-label="Tags"
                                aria-describedby="basic-addon11"
                            />
                        </div>
                    </>
                );
            case 3:
                return (
                    <div className="justify-content-center align-items-center mb-3">
                        <label htmlFor="appDescription" className="form-label">
                            Description
                        </label>
                        <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            value={description}
                            onChange={handleChange}
                            rows="4"
                        ></textarea>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="container-md">
            <div className="authentication-wrapper cd-flex justify-content-center align-items-center">
                {loading? (
                    <div className="spinner-border spinner-border-lg text-netikash" role="status">
                        <span className="visually-hidden">Chargement...</span>
                    </div>
                ) : <div className="card">
                    <div className="card-body">
                        <div className="app-brand justify-content-center">
                            <div className="mb-2">
                                <img src={require("../assets/img/illustrations/payment-app-vector-illustration.jpg")}
                                     alt="Netiaksh Logo" style={{width: 200}}/>
                            </div>
                        </div>
                        <h4 className="mb-4 text-netikash text-center">Création d'une organisation</h4>
                        <p className="mb-2 text-center">Veuillez remplir les informations ci-dessous pour créer votre organisation.</p>

                        <div className="row justify-content-center mb-4">
                            {/* Section gauche - Détails */}
                            <div className="col-md-6 w-px-500">
                                <div className="input-group mb-3">
                                  <span className="input-group-text" id="basic-addon11">
                                    Nom
                                  </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={organisationData.name}
                                        onChange={handleChange}
                                        placeholder="Nom de l'organisation"
                                        aria-label="orgName"
                                        aria-describedby="basic-addon11"
                                    />
                                </div>
                            </div>

                            {/* Section droite - Formulaire */}
                            <div className="col-md-6 w-px-500">
                                <div className="input-group mb-3">
                                    <label className="input-group-text" htmlFor="inputGroupSelect01">
                                        Catégories
                                    </label>
                                    <select
                                        className="form-select"
                                        id="inputGroupSelect01"
                                        name="category_id"
                                        value={organisationData.category_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Choisir...</option>
                                        {categories.map((item, index) => (
                                            <option key={index} value={item.id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>

                            </div>
                        </div>

                        <div className="row justify-content-center" style={{maxWidth:'1000px'}}>
                            <label htmlFor="appPage" className="form-label">
                                Lien de votre page
                            </label>
                            <div className="form-control align-items-center d-flex" style={{ maxWidth: "972px" }}>
                                <span className="text-muted" style={{ whiteSpace: "nowrap" }}>
                                    {hosts.api === "https://api.netikash.com" ? "https://subscribe.netikash.com" : "https://devsubscribe.netikash.com"}/
                                </span>
                                <input
                                    type="text"
                                    className="border-0 flex-grow-1"
                                    placeholder="nom-de-page"
                                    name="page"
                                    value={page || ""}
                                    onChange={(e) => {
                                        setPage(e.target.value);
                                        setIsValid(validerTexte(e.target.value));
                                    }}
                                    style={{ outline: "none" }}
                                    maxLength={20}
                                />
                                {isValid === true && (
                                    <CheckCircle color="green" size={20} className="ms-2" />
                                )}
                                {isValid === false && (
                                    <XCircle color="red" size={20} className="ms-2" />
                                )}
                            </div>

                            <div className="justify-content-center align-items-center mb-3">
                                <label htmlFor="appDescription" className="form-label">
                                    Description (Max 255 caractères)
                                </label>
                                <ReactQuill
                                    theme="snow"
                                    value={description}
                                    onChange={handleChangeNt}
                                />
                                <div className="d-flex align-items-center mt-2">
                                    {isDescriptionValid ? (
                                        <span className="tf-icons bx bx-check-circle text-success" style={{ fontSize: "1.5rem", marginRight: "8px" }}></span>
                                    ) : (
                                        <span className="tf-icons bx bx-x-circle text-danger" style={{ fontSize: "1.5rem", marginRight: "8px" }}></span>
                                    )}
                                    <span>{Math.max(0, 255 - realDescription.length)} caractères restants</span>
                                </div>
                            </div>
                        </div>

                        {/* Bouton de confirmation */}
                        <div className="d-flex justify-content-start">
                            <div className="d-flex justify-content-start w-100">
                                <button
                                    className="btn btn-outline-danger d-grid w-50 me-2"
                                    onClick={handleAbort}
                                >
                                    Annuler
                                </button>
                                <button
                                    className={!organisationData || !isValid || !isDescriptionValid ?
                                        "btn btn-netikash d-grid w-50 disabled" :
                                        "btn btn-netikash d-grid w-50"}
                                    onClick={handleSave}
                                >
                                    Créer Organisation
                                </button>
                            </div>
                        </div>

                    </div>
                </div>}
            </div>
        </div>
    );
};

export default OrganisationView;
